import React from 'react';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';

export const ToasterSuccessIcon = () => <CheckOutlinedIcon color="success" sx={{ fontSize: 'inherit' }} />;
